const StartSDKCode = `
app = beam.App(
  name="myapp",
  cpu=4,
  mem="32Gi",
  gpu="A10G",
  python_version="python3.8",
  python_packages=[
    "sklearn","numpy","xgboost","pandas"
  ],
)
`;

const DeploySDKCode = `
app.Trigger.RestAPI(
  inputs={"text": beam.Types.String()},
  outputs={"prediction": beam.Types.String()},
  handler="inference.py:predict_sentiment",
)
`;

const ConnectSDKCode = `
app.Mount.PersistentVolume(
  name="myvolume", app_path="./models"
)
`;

const Groups = [
  {
    title: "CLI",
    codeBlocks: [
      {
        code: "curl https://raw.githubusercontent.com/slai-labs/get-beam/main/get-beam.sh -sSfL | sh",
        name: "Install",
        description: "Download Beam",
        isScript: true
      },
      {
        code: "beam configure",
        name: "Configure",
        description: "Add API keys",
        isScript: true
      },
      {
        code: "beam start myapp.py",
        name: "Develop",
        description: "Connect a remote runtime",
        isScript: true
      },
      {
        code: "beam deploy myapp.py",
        name: "Deploy",
        description: "Instant REST API",
        isScript: true
      }
    ]
  },
  {
    title: "SDK",
    codeBlocks: [
      {
        code: StartSDKCode,
        name: "Start",
        description: "Remote Cloud Runtime"
      },
      {
        code: DeploySDKCode,
        name: "Deploy",
        description: "Instant REST API "
      },
      {
        code: ConnectSDKCode,
        name: "Connect",
        description: "Access data sources"
      }
    ]
  }
];

export default Groups;
